// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"c543db6a","97":"bc690136","209":"4702480b","293":"ca928d87","406":"2bae4590","743":"9a8a203a","925":"f9cd58e0"}[chunkId] + ".chunk.js";
};